import 'alpinejs';
import { flare } from '@flareapp/js';

import Alpine from 'alpinejs';
import moment from 'moment';
import { popper } from '@popperjs/core';
import tippy from 'tippy.js';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import '@lottiefiles/lottie-player';
require('es6-promise').polyfill();
import 'fetch-ie8';
import './form';

if (process.env.NODE_ENV === 'production') {
    flare.light();
}

window.localStorageIsSupported = function () {
    try {
        const key = '__test_ls_key__';
        localStorage.setItem(key, key);
        localStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
};

window.moment = moment;
window.Alpine = Alpine;
window.popper = popper;
window.tippy = tippy;
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.start();

window.addEventListener('beforeunload', function (e) {
    if (Alpine.store('formData').changesMade) {
        var confirmationMessage = 'Wijzigingen die u heeft aangebracht, worden mogelijk niet opgeslagen.';

        (e || window.event).returnValue = confirmationMessage; // Gecko + IE

        return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
    }
});

window.loadCalendly = () => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
    });
};
